module.exports = __webpack_public_path__ + "img/product-35.2855a990.jpg";